<template>
  <div>
    <!-- Animated header -->
    <transition :name="animationClass">
      <h1 v-if="isVisible" class="header">
        {{ categoryData.title }}
      </h1>
    </transition>

    <!-- Animated level cards -->
    <transition-group
      name="fade-slide"
      tag="div"
      class="level-container"
      appear
    >
      <LevelCard
        v-for="level in categoryData.levels"
        :key="level.index"
        :title="level.title"
        :image="level.image"
        :locked="false"
        @card-click="handleCardClick(level)"
      />
    </transition-group>
  </div>
</template>

<script>
import { categories } from "../utils/levelData.js";
import LevelCard from "../components/cards/LevelCard.vue";
import useEnterAnimation from "../composables/useEnterAnimation.js";

export default {
  name: "CategoryPage",
  components: {
    LevelCard,
  },
  setup() {
    const { isVisible, animationClass } = useEnterAnimation(100, "fade-slide");
    return { isVisible, animationClass };
  },
  data() {
    return {
      categoryData: {},
    };
  },
  created() {
    const categoryName = this.$route.params.category;
    this.categoryData = categories.find(
      (category) => category.name === categoryName
    );
    if (!this.categoryData) {
      this.$router.push("/");
    }
  },
  methods: {
    handleCardClick(level) {
      this.$router.push(`/${this.categoryData.name}/${level.index}`);
    },
  },
};
</script>

<style scoped>
.level-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  padding: 40px;
  max-width: 1000px;
  margin: auto;
}

@media (max-width: 600px) {
  .header {
    max-width: 80%;
    margin: auto
  }
  .level-container {
    padding: 20px;
  }
}

.header {
  font-size: 48px;
  text-align: center;
  margin-top: 20px;
}

/* === Animation Classes === */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 2s ease, transform 2s ease;
}
.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.fade-slide-enter-to,
.fade-slide-leave-from {
  opacity: 1;
  transform: translateY(0);
}
</style>